





































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import StarRating from "vue-star-rating";
import http from "@/methods/http.ts";

@Component({
  components: {
    StarRating,
  },
  filters: {
    image(value) {
      return value.trim().substring(0, 1);
    },
  },
})
export default class Specialist extends Vue {
  @Prop(String) name!: string;
  @Prop(Number) rating!: number;
  @Prop(Array) cats: Array;
  @Prop(String) desc: string;
  @Prop(Boolean) state: boolean;
  @Prop(String) address: string;
  @Prop(String) img: string;
  @Prop(String) slug: string;
  @Prop(Boolean) admin: boolean;
  @Prop(String) adminCompany: string;
  @Prop(Boolean) status!: boolean;
  @Prop(Array) company;
  @Prop(Number) reviewCount;

  startDate = moment().format("DD.MM.YYYY");
  isVisible = false;

  getSchedule() {
    let orgs = this.company;
    let orgs_list = [];
    orgs_list.push("-1");
    for (let key in orgs) {
      if (orgs[key].checked === true) {
        orgs_list.push(orgs[key].id);
      }
    }
    http(`masters/${this.slug}/schedule/beta`, "get", false, {
      day: this.startDate,
      day_count: 7,
      orgs: orgs_list,
    }).then((r) => {
      if (r.data.length) {
        this.isVisible = true;
      }
    });
  }

  mounted() {
    this.getSchedule();
  }
}
